import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({
  selector: '[zefSidenavBanner]',
  standalone: false,
})
export class SidenavBannerDirective {
  readonly tr = inject<TemplateRef<any>>(TemplateRef);
}
